import axios from "axios";

    export const validateToken = async (token) => {
        if (!token) {
            return false
        }

        try {
            const response = await axios.get('https://payments.leviton.com/api/validate-token', {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            if (response.status === 200) {
                const data = await response.data;
                return data.message === "Token is valid"
            } else {
                return false
            }
        } catch(error) {
            console.error('Token not found');
            return false
        }
    };